import {
    /** FETCH APPLICATION  */
    FETCH_PROFESSIONSV2_FULFILLED,
    FETCH_PROFESSIONSV2_REJECTED,
    FETCH_PROFESSIONSV2_PENDING,
    RESET_PROFESSIONSV2
} from "../../actions/v3/professions";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROFESSIONSV2_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PROFESSIONSV2_FULFILLED:
            return {
                ...state,
                professionsv2: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_PROFESSIONSV2_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_PROFESSIONSV2:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};